<template>
  <a class="text-sm" @click="viewOrder">{{ item.id }}</a>
</template>

<script>
export default {
  name: "order-status-id",
  props: {
    item: Object,
    options: Object,
  },
  methods: {
    viewOrder() {
      const options = this.viewOrderOptions(this.item.id);
      Dialog.open({ width: "900px", clickToClose: true, ...options });
    },
  },
};
</script>
